var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setuprogress"},[_c('div',[_vm._v(_vm._s(_vm.step)+"/3 completed")]),_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress",style:(`width:${(_vm.progress / 100) * 130}px`)})]),_c('div',[_vm._v("Skip")])])
}
var staticRenderFns = []

export { render, staticRenderFns }